import Axios from "axios";
import config from "../app.config";

let customerService;
export default customerService = {
    getCustomers,
    getCustomer,
    updateCustomer,
    createCustomer,
    deleteCustomers,
    deleteCustomer,
    search,
    importCustomer,
    createCustomerField,
    getCustomerFieldsByCompany,
    updateFieldNameCompanyCustomize,
    deleteFieldNameCompanyCustomize,
}
async function importCustomer(data, headers) {
    return await Axios.post(`${config.LOCAL_API_URL}/customer/import`, data, { headers })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data);
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function search(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/customer/search`, { params: payload })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error);
        })
}
async function getCustomers(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/customer`, { params: payload })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error);
        })
}
async function getCustomer(id) {
    return await Axios.get(`${config.LOCAL_API_URL}/customer/` + id)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function updateCustomer(data) {
    return await Axios.put(`${config.LOCAL_API_URL}/customer/` + data.id, data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function deleteCustomers(params) {
    return await Axios.delete(`${config.LOCAL_API_URL}/customer`, { data: params })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function deleteCustomer(id) {
    return await Axios.delete(`${config.LOCAL_API_URL}/customer/${id}`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function createCustomer(params) {
    return await Axios.post(`${config.LOCAL_API_URL}/customer`, params)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function createCustomerField(params){
    return await Axios.post(`${config.LOCAL_API_URL}/customer-company-settings`, params)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function getCustomerFieldsByCompany(){
    return await Axios.get(`${config.LOCAL_API_URL}/customer-company-settings`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function updateFieldNameCompanyCustomize(data){
    return await Axios.put(`${config.LOCAL_API_URL}/customer-company-settings/${data.id}`, data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}

async function deleteFieldNameCompanyCustomize(id){
    return await Axios.delete(`${config.LOCAL_API_URL}/customer-company-settings/${id}`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
